export const KEEPS_ITS_HEIGHT_CLASS = "element-keeps-its-height";

const HORIZONTAL_TYPES = new Set(["HorizontalContainerWrapper", "HorizontalContainer"]);
const SET_DIRECTIONS = new Set(["vertical", "horizontal", "horizontal-wrap"]);

function laysOutAsRow({ elementType, direction }) {
  if (SET_DIRECTIONS.has(direction)) {
    return direction !== "vertical";
  }
  return HORIZONTAL_TYPES.has(elementType);
}

export function holdsPageSections({ elementId, rootElementId, elementType, direction }) {
  return String(elementId) === String(rootElementId) && !laysOutAsRow({ elementType, direction });
}

export function keepsItsHeight({ inPageRoot, layoutHeight }) {
  return inPageRoot && !/fill/i.test(String(layoutHeight ?? ""));
}
